import { MultiProductRoutes } from 'src/app/multi_product/mp.routes';
import { PagesRoutes } from 'src/app/pages/page.routes';
import { QuoteRoutes } from 'src/app/quote/quote.routes';

const quoteRoutes = QuoteRoutes.ROUTES;

const pagesRoutes = PagesRoutes.ROUTES;

const mpRoutes = MultiProductRoutes.ROUTES;

// 'CBMC' -> Buzon Comercial/Placement
// 'PRMC' -> Configurador prodcutos
// 'CAMC' -> Configurador Catálogos
// 'GPMC' -> Gestión Pólizas
// 'SBMC' -> Buzón Suscripción
// 'OBMC' -> Buzón Operaciones
// 'CMMC' -> Gestión Clientes
// 'COMC' -> Buzón Cumplimiento
// 'IMMC' -> Gestión Intermediarios
// 'MKMC' -> Campañas de Marketing
// 'PMMC' -> Gestion de Cuotas

export const BR_CARD_DATA = {
  CBMC: {
    title: 'Painel Placement',
    text: 'Cria ou gerencia propostas ou endossos de apólices.',
  },
  PRMC: {
    title: 'Configurador de Produtos',
    text: 'Crie ou edite seus produtos.',
  },
  CAMC: {
    title: 'Configurador de Catálogos',
    text: 'Crie ou edite catálogos para seus produtos.',
  },
  GPMC: {
    title: 'Gestão de Apólices',
    text: 'Administre tudo relacionado às apólices emitidas.',
  },
  SBMC: { title: 'Buzón de Suscrição', text: 'Gerencie propostas pendentes.' },
  OBMC: { title: 'Painel Operações', text: 'Gerencie propostas pendentes.' },
  CMMC: {
    title: 'Gestão de Clientes',
    text: 'Revisar todas as informações dos clientes.',
  },
  COMC: { title: 'Painel Compliance', text: 'Gerenciar propostas pendentes.' },
  IMMC: {
    title: 'Gestão de Intermediarios',
    text: 'Gerencia tudo relacionado a intermediários.',
  },
  BMMC: {
    title: 'Gestão de Beneficiários',
    text: 'Gerencia tudo relacionado a beneficiários.',
  },
  MKMC: {
    title: 'Campanhas de Marketing',
    text: 'Gerencia campanhas de marketing.',
  },
  PMMC: {
    title: 'Gestão de Parcelas',
    text: 'Verificar a informações de qualquer parcela.',
  },
};

export const US_CARD_DATA = {
  CBMC: {
    title: 'Commercial Mailbox',
    text: 'Creates or manages policy proposals or endorsements.',
  },
  PRMC: {
    title: 'Product Configurator',
    text: 'Create or edit your products.',
  },
  CAMC: {
    title: 'Catalog Configurator',
    text: 'Create or edit catalogs for your products.',
  },
  GPMC: {
    title: 'Policy Management',
    text: 'Manage everything related to issued policies.',
  },
  SBMC: { title: 'Subscription Box', text: 'Manage pending proposals.' },
  OBMC: { title: 'Operations Box', text: 'Manage pending proposals.' },
  CMMC: {
    title: 'Customer Management',
    text: 'Review any customers information.',
  },
  COMC: { title: 'Compliance Box', text: 'Manages pending proposals.' },
  IMMC: {
    title: 'Intermediary Management',
    text: 'Manages pending proposals.',
  },
  MKMC: {
    title: 'Marketing Campaigns',
    text: 'Manages marketing campaigns.',
  },
  PMMC: {
    title: 'Quotes Management',
    text: 'Verify information of your quotes.',
  },
};

export const MENU_CARDS = {
  ARTICO_MP_MENU_GROUP_COMMERCIAL: {
    title: 'Buzón Comercial',
    text: ['Crea o gestiona propuestas de póliza o endoso.'],
    backgroundColor: '#FF5A00',
    url: '/multiproduct/proposals-box',
    type: 'menuGeneral',
    img: 'assets/img/svg/bandeja-icon.svg',
    code: 'CBMC',
  },
  ARTICO_MP_MENU_CONFIG_PRODUCTS: {
    title: 'Configurador de Productos',
    text: ['Crea o edita tus productos.'],
    backgroundColor: '#0031E2',
    url: '/multiproduct/products',
    type: 'menuGeneral',
    img: 'assets/img/svg/config-icon.svg',
    code: 'PRMC',
  },
  ARTICO_MP_MENU_CONFIG_CATALOGS: {
    title: 'Configurador de Catálogos',
    text: ['Crea o edita los catálogos para tus productos.'],
    backgroundColor: '#990587',
    url: '/multiproduct/catalogs',
    type: 'menuGeneral',
    img: 'assets/img/svg/catalog-icon.svg',
    code: 'CAMC',
  },
  ARTICO_MP_MENU_MANAGE_POLICIES: {
    title: 'Gestión de Pólizas',
    text: ['Administra todo lo relacionado a las pólizas emitidas.'],
    backgroundColor: '#51009D',
    url: '/multiproduct/manage-policies',
    type: 'menuGeneral',
    img: 'assets/img/svg/folder-icon.svg',
    code: 'GPMC',
  },
  ARTICO_MP_MENU_GROUP_SUBSCRIPTION: {
    title: 'Buzón de Suscripción',
    text: ['Gestiona las propuestas pendientes.'],
    backgroundColor: '#0031E2',
    url: '/multiproduct/subscription-box',
    type: 'menuGeneral',
    img: 'assets/img/svg/subs-buzon-icon.svg',
    code: 'SBMC',
  },
  ARTICO_MP_MENU_GROUP_OPERATIONS: {
    title: 'Buzón de Operaciones',
    text: ['Gestiona las propuestas pendientes.'],
    backgroundColor: '#51009D',
    url: '/multiproduct/operations-box',
    type: 'menuGeneral',
    img: 'assets/img/svg/operation-buzon-icon.svg',
    code: 'OBMC',
  },
  ARTICO_MP_MENU_MANAGE_CUSTOMERS: {
    title: 'Gestión de Clientes',
    text: ['Revisa la información de cualquier cliente.'],
    backgroundColor: '#29ABE2',
    url: '/multiproduct/manage-customers',
    type: 'menuGeneral',
    img: 'assets/img/svg/client-management-icon.svg',
    code: 'CMMC',
  },
  ARTICO_MP_MENU_MANAGE_BENEFICIARIES: {
    title: 'Gestión de Beneficiarios',
    text: ['Revisa la información de cualquier beneficiario.'],
    backgroundColor: '#29ABE2',
    url: '/multiproduct/manage-beneficiaries',
    type: 'menuGeneral',
    img: 'assets/img/svg/client-management-icon.svg',
    code: 'BMMC',
  },
  ARTICO_MP_MENU_GROUP_COMPLIANCE: {
    title: 'Buzón de Cumplimiento',
    text: ['Gestiona las propuestas pendientes.'],
    backgroundColor: '#FF5A00',
    url: '',
    type: 'menuGeneral',
    img: 'assets/img/svg/document-check-icon.svg',
    code: 'COMC',
  },
  ARTICO_MP_MENU_MANAGE_INTERMEDIARIES: {
    title: 'Gestión de Intermediarios',
    text: ['Administra todo lo relacionado a los intermediarios.'],
    backgroundColor: '#990587',
    url: '/multiproduct/manage-intermediaries',
    type: 'menuGeneral',
    img: 'assets/img/svg/persons-icon.svg',
    code: 'IMMC',
  },
  ARTICO_MP_MENU_MARKETING: {
    title: 'Campañas de Marketing',
    text: ['Administra campañas de marketing.'],
    backgroundColor: '#51009D',
    url: '/multiproduct/marketing',
    type: 'menuGeneral',
    img: 'assets/img/svg/arrow-scale.svg',
    code: 'MKMC',
  },
  ARTICO_MP_MENU_PARCELAS: {
    title: 'Gestion de Cuotas',
    text: ['Administra tus cuotas'],
    backgroundColor: '#51009D',
    url: '/multiproduct/quotes',
    type: 'menuGeneral',
    img: 'assets/img/svg/option-quotes.svg',
    code: 'PMMC',
  },
  propertyInsurance: {
    title: 'Propiedad',
    text: [],
    backgroundColor: '#0031E2',
    url: '',
  },
  engineering: {
    title: 'Ingeniería',
    text: [],
    backgroundColor: '#51009D',
    url: '',
  },
  civilLiability: {
    title: 'Responsabilidad Civil',
    text: [],
    backgroundColor: '#29ABE2',
    url: '',
  },
  quote: {
    title: 'Solicitud',
    text: ['Solicita el seguro en pocos pasos'],
    backgroundColor: '#29ABE2',
    url: '/quote/steps/main-data',
  },
  previousQuotes: {
    title: 'Bandeja de atención',
    text: ['Continua y revisa todas las solicitudes y propuestas'],
    backgroundColor: '#990587',
    url: '/quote/help-desk',
  },
  policiesSold: {
    title: 'Consulta de póliza',
    text: ['Revisa el detalle de las pólizas emitidas'],
    backgroundColor: '#51009D',
    url: '/quote/policies-sold',
  },
  emissionEngineering: {
    title: 'Emissão ',
    text: ['Preencher as informações para emitir uma apólice'],
    backgroundColor: '#29ABE2',
    url: '/engineering/flow',
  },
  attentionEngineeringTray: {
    title: 'Solicitações e propostas ',
    text: ['Continue a cotação de onde você parou'],
    backgroundColor: '#990587',
    url: '/engineering/proposals-list',
  },
  policyConsultationEngineering: {
    title: 'Consulta ao apólice ',
    text: ['Gerencie as apólices emitidas'],
    backgroundColor: '#51009D',
    url: '/engineering/policy-list',
  },
  emission: {
    title: 'Emissão',
    text: ['Preencher as informações para emitir uma apólice'],
    backgroundColor: '#29ABE2',
    url: ['/flow/traditional', '/flow/massive'],
  },
  attentionTray: {
    title: 'Solicitações e propostas',
    text: ['Continue a cotação de onde você parou'],
    backgroundColor: '#990587',
    url: '/help-desk',
  },
  policyConsultation: {
    title: 'Consulta ao apólice',
    text: ['Gerencie as apólices emitidas'],
    backgroundColor: '#51009D',
    url: '/policies',
  },
  flowMassive: {
    title: 'Emissão Cacau Show',
    text: [],
    backgroundColor: '#29ABE2',
    url: '/flow/massive',
  },
  flowTraditional: {
    title: 'Emissão tradicional',
    text: [],
    backgroundColor: '#0031E2',
    url: '/flow/traditional',
  },
  propertyInsuranceBR: {
    title: 'Seguro de Property',
    text: ['Começa uma nova cotação'],
    backgroundColor: '#FF5A00',
    url: '/propertyMenu',
    type: 'menuGeneral',
    img: 'assets/img/svg/propertyInsurance-icon.svg',
  },
  engineeringMenuBR: {
    title: 'Seguro de Engenharia',
    text: ['Começa uma nova cotação'],
    backgroundColor: '#0031E2',
    url: '/engineeringMenu',
    type: 'menuGeneral',
    img: 'assets/img/svg/engineering-icon.svg',
  },
};

export enum PageNames {
  ARTICO_PE_START = 'Inicio',
  ARTICO_PE_LEAVE = 'Salir',
  ARTICO_PE_PROPERTY = 'Seguros de propiedad',
  ARTICO_PE_PROPERTY_QUOTE = 'Solicitar',
  ARTICO_PE_PROPERTY_HELP_DESK = 'Bandeja de atención',
  ARTICO_PE_PROPERTY_POLICIES = 'Consulta de póliza',
  ARTICO_BR_PROPERTY = 'Seguros de Property',
  ARTICO_BR_PROPERTY_FLOWMASSIVE = 'Emissão Cacau Show',
  ARTICO_BR_PROPERTY_FLOWTRADITIONAL = 'Emissão tradicional',
  ARTICO_BR_PROPERTY_HELPDESK = 'Solicitações e propostas',
  ARTICO_BR_PROPERTY_POLICIES = 'Consulta ao apólice',
  ARTICO_BR_ENGINEERING = 'Seguro de Engenharia',
  ARTICO_BR_ENGINEERING_FLOWTRADITIONAL = 'Emissão',
  ARTICO_BR_ENGINEERING_HELPDESK = 'Solicitações e propostas',
  ARTICO_BR_ENGINEERING_POLICIES = 'Consulta ao apólice',
  ARTICO_MP_MENU_HOME = 'Home',
  ARTICO_MP_MENU_CONFIG_PRODUCTS = 'MP-MENU-CONFIG-PRODUCTS',
  ARTICO_MP_MENU_CONFIG_CATALOGS = 'MP-MENU-CONFIG-CATALOGS',
  ARTICO_MP_MENU_GROUP_COMMERCIAL = 'MP-MENU-GROUP-COMMERCIAL',
  ARTICO_MP_MENU_GROUP_SUBSCRIPTION = 'MP-MENU-GROUP-SUBSCRIPTION',
  ARTICO_MP_MENU_GROUP_OPERATIONS = 'MP-MENU-GROUP-OPERATIONS',
  ARTICO_MP_MENU_MANAGE_POLICIES = 'MP-MENU-MANAGE-POLICIES',
  ARTICO_MP_MENU_GROUP_COMPLIANCE = 'MP-MENU-COMPLIANCE',
  ARTICO_MP_MENU_MANAGE_CUSTOMERS = 'MP-MENU-MANAGE-CUSTOMERS',
  ARTICO_MP_MENU_MANAGE_BENEFICIARIES = 'MP_MENU_MANAGE_BENEFICIARIES',
  ARTICO_MP_MENU_MANAGE_INTERMEDIARIES = 'MP-MENU-MANAGE-INTERMEDIARIES',
  ARTICO_MP_MENU_MARKETING = 'ARTICO-MP-MENU-MARKETING',
  ARTICO_MP_MENU_PARCELAS = 'ARTICO-MP-MENU-PARCELAS',
}

export const VIEW_ITEMS = {
  Solicitud: {
    route: quoteRoutes.Steps.StepMainData.fullPath,
    menu: 'quote',
  },
  'Bandeja de atención': {
    route: quoteRoutes.HelpDesk.fullPath,
    menu: 'help-desk',
  },
  'Consulta de póliza': {
    route: quoteRoutes.PoliciesSold.fullPath,
    menu: 'policies-sold',
  },
  'Solicitações e propostas': {
    route: pagesRoutes.HelpDesk.fullPath,
    menu: 'help-desk',
  },
  'Consulta ao apólice': {
    route: pagesRoutes.Policies.fullPath,
    menu: 'policies',
  },
  'Emissão Cacau Show': {
    route: pagesRoutes.Flow.Massive.fullPath,
    menu: 'flow-massive',
  },
  'Emissão ': {
    route: pagesRoutes.Engineering.Flow.Steps.StepMainData.fullPath,
    menu: 'engineering-flow',
  },
  'Solicitações e propostas ': {
    route: pagesRoutes.Engineering.HelpDesk.fullPath,
    menu: 'proposal-list',
  },
  'Consulta ao apólice ': {
    route: pagesRoutes.Engineering.Policies.fullPath,
    menu: 'policy-list',
  },
  'Configurador de Catálogos': {
    route: mpRoutes.Catalogs.fullPath,
    menu: 'main',
  },
  'Catalog Configurator': {
    route: mpRoutes.Catalogs.fullPath,
    menu: 'main',
  },
  'Configurador de Productos': {
    route: mpRoutes.Products.fullPath,
    menu: 'main',
  },
  'Product Configurator': {
    route: mpRoutes.Products.fullPath,
    menu: 'main',
  },
  'Configurador de Produtos': {
    route: mpRoutes.Products.fullPath,
    menu: 'main',
  },
  'Gestión de Pólizas': {
    route: mpRoutes.ManagePolicies.fullPath,
    menu: 'main',
  },
  'Policy Management': {
    route: mpRoutes.ManagePolicies.fullPath,
    menu: 'main',
  },
  'Gestão de Apólices': {
    route: mpRoutes.ManagePolicies.fullPath,
    menu: 'main',
  },
  'Buzón Comercial': {
    route: mpRoutes.ProposalsBox.fullPath,
    menu: 'main',
  },
  'Commercial Mailbox': {
    route: mpRoutes.ProposalsBox.fullPath,
    menu: 'main',
  },
  'Painel Placement': {
    route: mpRoutes.ProposalsBox.fullPath,
    menu: 'main',
  },
  'Caixa de Propostas': {
    route: mpRoutes.ProposalsBox.fullPath,
    menu: 'main',
  },
  'Buzón de Suscripción': {
    route: mpRoutes.SubscriptionsBox.fullPath,
    menu: 'main',
  },
  'Subscription Box': {
    route: mpRoutes.SubscriptionsBox.fullPath,
    menu: 'main',
  },
  'Buzón de Suscrição': {
    route: mpRoutes.SubscriptionsBox.fullPath,
    menu: 'main',
  },
  'Buzón de Operaciones': {
    route: mpRoutes.OperationsBox.fullPath,
    menu: 'main',
  },
  'Operations Box': {
    route: mpRoutes.OperationsBox.fullPath,
    menu: 'main',
  },
  'Painel Operações': {
    route: mpRoutes.OperationsBox.fullPath,
    menu: 'main',
  },
  'Gestión de Clientes': {
    route: mpRoutes.CustomerManagement.fullPath,
    menu: 'main',
  },
  'Gestión de Beneficiarios': {
    route: mpRoutes.BeneficiaryManagement.fullPath,
    menu: 'main',
  },
  'Gestão de Beneficiários': {
    route: mpRoutes.BeneficiaryManagement.fullPath,
    menu: 'main',
  },
  'Gestão de Clientes': {
    route: mpRoutes.CustomerManagement.fullPath,
    menu: 'main',
  },
  'Customer Management': {
    route: mpRoutes.CustomerManagement.fullPath,
    menu: 'main',
  },
  'Gestión de Intermediarios': {
    route: mpRoutes.IntermediaryManagement.fullPath,
    menu: 'main',
  },
  'Gestão de Intermediarios': {
    route: mpRoutes.IntermediaryManagement.fullPath,
    menu: 'main',
  },
  'Intermediary Management': {
    route: mpRoutes.IntermediaryManagement.fullPath,
    menu: 'main',
  },
  'Buzón de Cumplimiento': {
    route: mpRoutes.ComplienceBox.fullPath,
    menu: 'main',
  },
  'Compliance Box': {
    route: mpRoutes.ComplienceBox.fullPath,
    menu: 'main',
  },
  'Painel Compliance': {
    route: mpRoutes.ComplienceBox.fullPath,
    menu: 'main',
  },
  'Campañas de Marketing': {
    route: mpRoutes.MarketingBox.fullPath,
    menu: 'main',
  },
  'Marketing Campaigns': {
    route: mpRoutes.MarketingBox.fullPath,
    menu: 'main',
  },
  'Campanhas de Marketing': {
    route: mpRoutes.MarketingBox.fullPath,
    menu: 'main',
  },
  'Quotes Management': {
    route: mpRoutes.QuotesBox.fullPath,
    menu: 'main',
  },
  'Gestion de Cuotas': {
    route: mpRoutes.QuotesBox.fullPath,
    menu: 'main',
  },
  'Gestão de Parcelas': {
    route: mpRoutes.QuotesBox.fullPath,
    menu: 'main',
  }
};
